import { useImmer } from "use-immer";
import { createPassword } from "..";
import { useMutation } from "@tanstack/react-query";
import { useModal } from "shared";
import { errorFormatter } from "utils";

export const useGeneratePassword = () => {
  const { modalState, onOpenModal, onCloseModal } = useModal();
  const [payload, setPayload] = useImmer({
    emailAddress: "",
    registrationId: "",
  });

  const mutationFn = useMutation({
    mutationFn: createPassword,
    onSuccess: () => {
      onOpenModal({
        actionFrom: "passwordReset",
      });
    },
    onError: (e) => {
      errorFormatter(e);
    },
  });

  return {
    payload,
    setPayload,
    mutationFn,
    modalState,
    onCloseModal,
  };
};
